import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import defaultCardImage from "../../../assets/images/home-page/howItWork/default-card-img.svg";
import { StyledCardBlockImage, StyledCardBlockInfo, StyledContentCardBlock } from "./styledHowItWork";
import { StyledDecorationElementHomePage } from "../styledHomePage";
import { NavLink } from "react-router-dom";

const ContentCardBlock = ({ text, src, index, link, manualKey }) => {
  return (
    <StyledContentCardBlock
      as={NavLink}
      to={{
        pathname: link,
        state: { manualKey }
      }}
    >
      <StyledCardBlockInfo>
        <StyledDecorationElementHomePage
          color="#9B68E4"
          size="80"
          weight="700"
          lineHeight="70"
        >
          {index}
        </StyledDecorationElementHomePage>
        <StyledDecorationElementHomePage
          lineHeight="20"
          color="#646464"
          weight="300"
          size="16"
          display="block"
          maxWidth="280"
        >{text}</StyledDecorationElementHomePage>
      </StyledCardBlockInfo>
      <StyledCardBlockImage>
        <LazyLoadImage
          src={src ?? defaultCardImage}
          width={250}
          height={160}
          visibleByDefault={src ?? defaultCardImage}
        />
      </StyledCardBlockImage>
    </StyledContentCardBlock>
  );
};

export default ContentCardBlock;